import React from "../../__compat__/react/main.entry.mjs.mjs";
import { Text } from "../Text/index.mjs.mjs";
import { SmallScreenHeading, StyledTableCell } from "./Table.styles.mjs.mjs";
import { TableContext } from "./Table.context.mjs.mjs";
export const TableCell = React.forwardRef(({ children, columnHeading, width, colSpan, rowSpan, }, ref) => {
    const tableContext = React.useContext(TableContext);
    return (React.createElement(StyledTableCell, { ref: ref, role: "cell", width: width, colSpan: colSpan, rowSpan: rowSpan, hasSmallScreenHeading: Boolean(columnHeading), displayMode: tableContext.displayMode },
        columnHeading ? (React.createElement(SmallScreenHeading, { "aria-hidden": "true", displayMode: tableContext.displayMode },
            React.createElement(Text, { as: "span", variant: "copy1", weight: "bold" }, columnHeading))) : null,
        children));
});
TableCell.displayName = 'TableCell';
//# sourceMappingURL=TableCell.mjs.mjs.map